/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudArrowUploadIcon24Solid = forwardRef('NetCloudArrowUploadIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M11.1 0a6.6 6.6 0 0 1 5.981 3.806A6.6 6.6 0 0 1 16.801 17H13.25v-6.782l2.066 2.066a1.25 1.25 0 1 0 1.768-1.768l-3.351-3.351a2.45 2.45 0 0 0-3.465 0l-3.352 3.351a1.25 1.25 0 0 0 1.768 1.768l2.066-2.066V17H6.6A6 6 0 0 1 4.621 5.334 6.602 6.602 0 0 1 11.1 0Z" }),
        React.createElement("path", { d: "M10.75 22v-5h2.5v5a1.25 1.25 0 1 1-2.5 0Z" })));
});
